import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail, Facebook, Instagram } from 'lucide-react';
import { companyInfo, services } from '../../data/mock';
import { cn } from '../../lib/utils';
import { Button } from '../ui/Button';

export const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'Početna', path: '/' },
    { name: 'O Nama', path: '/o-nama' },
    { name: 'Usluge', path: '/usluge' },
    { name: 'Galerija', path: '/galerija' },
    { name: 'Recenzije', path: '/recenzije' },
    { name: 'Kontakt', path: '/kontakt' },
  ];

  return (
    <header
      className={cn(
        'fixed top-0 left-0 right-0 z-50 transition-all duration-300',
        scrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'
      )}
    >
      {/* Top Bar */}
      <div className={cn(
        "hidden lg:block container mx-auto px-4 mb-2 transition-opacity duration-300",
        scrolled ? "opacity-0 h-0 overflow-hidden" : "opacity-100"
      )}>
        <div className="flex justify-between items-center text-sm text-white/90">
          <div className="flex items-center gap-6">
            <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-2 hover:text-white">
              <Phone size={16} />
              {companyInfo.phone}
            </a>
            <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-2 hover:text-white">
              <Mail size={16} />
              {companyInfo.email}
            </a>
          </div>
          <div className="flex items-center gap-4">
            <a href={companyInfo.facebook} target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <Facebook size={18} />
            </a>
            <a href={companyInfo.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <Instagram size={18} />
            </a>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 z-50">
            <img 
              src="https://i.ibb.co/vxzYNfLx/Screenshot-1-removebg-preview.png" 
              alt="Stolarija Leskovac Logo" 
              className="h-16 w-auto object-contain"
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={cn(
                  "text-sm font-medium uppercase tracking-wide transition-colors hover:text-secondary",
                  scrolled ? "text-gray-800" : "text-white",
                  location.pathname === link.path && "text-secondary"
                )}
              >
                {link.name}
              </Link>
            ))}
            <Button 
              variant={scrolled ? "primary" : "white"} 
              size="sm"
              onClick={() => window.location.href = '/kontakt'}
            >
              Zatraži Ponudu
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className={cn(
              "lg:hidden z-50 p-2",
              scrolled ? "text-gray-800" : "text-white"
            )}
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={cn(
          "fixed inset-0 bg-primary z-40 flex flex-col justify-center items-center transition-transform duration-300 lg:hidden",
          isOpen ? "translate-x-0" : "translate-x-full"
        )}
      >
        <nav className="flex flex-col items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="text-2xl font-bold text-white uppercase tracking-wider hover:text-secondary transition-colors"
              onClick={() => setIsOpen(false)}
            >
              {link.name}
            </Link>
          ))}
          <Button 
            variant="white" 
            size="lg"
            onClick={() => {
              setIsOpen(false);
              window.location.href = '/kontakt';
            }}
          >
            Zatraži Ponudu
          </Button>
        </nav>
      </div>
    </header>
  );
};
